import { render } from "./ImpressumEN.vue?vue&type=template&id=288af216&lang=en"
import script from "./ImpressumEN.vue?vue&type=script&lang=js"
export * from "./ImpressumEN.vue?vue&type=script&lang=js"

import exportComponent from "M:\\Me\\WebPortfolio_2022\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__